module.exports = __webpack_public_path__ + "img/shorts.79b07335.png";